import { VariaveisAmbiente } from 'config';
import { ApiListModel } from 'model/api/gestao/api-list-model/api-list-model';
import { FilialModel } from 'model/api/gestao/contrato/contrato-filial-model';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';

export function useGetFiliais() {
    const { invocarApi, ...outrasPropriedades } = useApiBase<ApiListModel<FilialModel>>();

    const getFiliais = useCallback(
        async (contratoId: string, page: number, queryBusca: string) => {
            let queryPage = "";
            if (page) {
                queryPage = "page=" + page.toString();
            }
            const queryFinal = `${queryPage?.length > 0 || queryBusca?.length > 0 ? "?" : ""
                }${queryPage}${queryPage.length > 0 ? "&" : ""}${queryBusca}`;

            return invocarApi({
                url: `${VariaveisAmbiente.apiVersion}/contrato/${contratoId}/filial${queryFinal}`,
                method: 'GET',
                enviarTokenUsuario: true
            })
        }
        , [invocarApi]
    );
    return {
        ...outrasPropriedades,
        getFiliais,
    };
}
